import React from "react";
import appConst from "../Utilities/appConst.json";
import "../styles/basketItemDiscount.css";
import BasketItemDefaultDetails from "./BasketItemDefaultDetails";

const BasketItemDetails = (props) => {
  const grossPrice = props?.item?.base_price * props?.item?.quantity;
  const discounts =
    props?.item?.additional_discount > 0
      ? props?.item?.additional_discount * props?.item?.quantity
      : 0;
  const netPrice = grossPrice - discounts;

  return (
    <div className="flex flex-col sm:gap-3 gap-2 h-full">
      <div>
        <h3 className="m-0 sm:text-xl text-base font-semibold text-secondary-foreground">
          {props.title}
        </h3>
      </div>

      <BasketItemDefaultDetails
        isMosaic={props.isMosaic}
        quantity={props.quantity}
        subTitle={props.subTitle}
        item={props.item}
        dropDowns={props.dropDowns}
        pagesNumber={props.pagesNumber}
        grossPrice={grossPrice}
        netPrice={netPrice}
        hasDiscount={discounts > 0}
        setCountValue={props.setCountValue}
        imageUrl={props.imageUrl}
        tuneSettingsTitle={props.tuneSettingsTitle}
        tuneSettingsFooter={props.tuneSettingsFooter}
        tuneSettingsMobileFooter={props.tuneSettingsMobileFooter}
        upgradeBanner={props.upgradeBanner}
      />
    </div>
  );
};
export default BasketItemDetails;
